// The one automation handle for a repeated picker child (BUG-2368): every option row,
// menu row and segment is `<ns>-<key>` plus `data-option-key`, never a generic id.

/** The two attributes every repeated picker child carries. */
export interface OptionHandleProps {
    'data-testid': string | undefined;
    'data-option-key': string;
}

/**
 * Handle for one repeated picker child. The key is the child's identity (its value or
 * id), never its label. `data-option-key` is always present: it is a key, not a handle,
 * so a check can pick a row without knowing the namespace. `data-testid` is
 * `<ns>-<key>` and absent when the picker has no namespace.
 *
 * @param params.ns The picker's automation namespace, or undefined for none.
 * @param params.key The child's identity (option value, row id, transition key).
 * @returns Props to spread onto the child's root element.
 */
export function optionHandle(params: { ns: string | undefined; key: string }): OptionHandleProps {
    const { ns, key } = params;
    return {
        'data-testid': ns ? `${ns}-${key}` : undefined,
        'data-option-key': key,
    };
}
